export const ARCHIVE_CATEGORIES = [
  ["all", "All frequencies"], ["eeg", "EEG bands"], ["schumann", "Schumann harmonics"],
  ["solfeggio", "Solfeggio / tuning"], ["focus", "Focus patterns"], ["archive", "Archive sets"],
];

export function archiveCategory(entry) {
  const label = entry.condition.toLowerCase();
  if (label.includes("🧠") || label.includes("waves")) return "eeg";
  if (label.includes("schumann")) return "schumann";
  if (label.includes("💚")) return "solfeggio";
  if (label.includes("🎯")) return "focus";
  return "archive";
}

export const presetName = preset => preset.id === "tourette-1" ? "SMR 432" : preset.label;
export const playableFrequency = hz => Number.isFinite(hz) && hz > 0 && hz <= 20000;
export const frequencyLabel = hz => `${Number(hz).toLocaleString("en-US", { maximumFractionDigits: 4 })} Hz`;